/**
 * Video Validate
 *
 * Validation rules for uploaded video files and picker constraints.
 */

import { VideoUtils } from "./video-utils";

interface VideoValidateConfig {
    allowedTypes?: string[];
    maxSize?: number;
    _maxCount?: number;
}

interface VideoValidationResult {
    isValid: boolean;
    errors: string[];
}

class VideoValidate {
    public static validateVideo(file: File, config: VideoValidateConfig = {}): VideoValidationResult {
        const {
            allowedTypes = ["video/mp4", "video/webm", "video/ogg", "video/quicktime", "video/avi"],
            maxSize = 50 * 1024 * 1024,
            _maxCount = 5,
        } = config;

        void _maxCount;

        const result: VideoValidationResult = {
            isValid: true,
            errors: [],
        };

        if (!allowedTypes.includes(file.type)) {
            result.isValid = false;
            result.errors.push(`Unsupported video format: ${file.type}`);
        }

        if (file.size > maxSize) {
            result.isValid = false;
            result.errors.push(
                `File too large: ${VideoUtils.formatFileSize(file.size)} (max: ${VideoUtils.formatFileSize(maxSize)})`,
            );
        }

        return result;
    }
}

export { VideoValidate };
